'use client';

import { CatPagination } from 'components/blocks-components';
import styles from './pagination.module.scss';
import cx from 'classnames';
import useFilter from 'hooks/use-filter';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';
import { useCallback } from 'react';
import { BlocksPageChangeEvent } from '@blocks-web-components/events';
import { PAGE_SIZE } from 'app/[lang]/[esite]/(core)/category/[category]/constants';

const Pagination = ({
  productCount,
  currentPage
}: {
  productCount: string;
  currentPage: string;
}) => {
  const updatedProductCount = +productCount > 1200 ? 1200 : +productCount;
  const { handlePageChange } = useFilter();
  const { startTransition } = useLoaderOverlay();
  const page = isNaN(Number(currentPage)) ? 1 : Number(currentPage);

  const onPageChange = useCallback(
    (e: BlocksPageChangeEvent) => {
      startTransition(() => {
        handlePageChange(e.detail.pageNumber);
      });
    },
    [handlePageChange, startTransition]
  );

  return (
    <CatPagination
      data-testid="pagination"
      totalRecords={updatedProductCount}
      className={cx('w-100', styles['pagination'])}
      pageSize={PAGE_SIZE}
      onBlPageChange={onPageChange}
      currentItem={page}
    />
  );
};

export default Pagination;
